import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountType, CampaignType } from "@front/m19-api-client";
import { AccountSelectionService, SbStrategyService } from "@front/m19-services";
import { of, startWith, switchMap } from "rxjs";
import { TranslocoDirective } from "@jsverse/transloco";
import { StrategyListComponent } from "@m19-board/strategies/strategy-list/strategy-list.component";

@Component({
  selector: "app-sd-manager",
  templateUrl: "./sd-manager.component.html",
  imports: [TranslocoDirective, StrategyListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdManagerComponent {
  private sbStrategyService = inject(SbStrategyService);
  private accountSelectionService = inject(AccountSelectionService);

  readonly hasBrand = toSignal(
    this.accountSelectionService.singleAccountMarketplaceSelection$.pipe(
      switchMap((am) =>
        am.accountType == AccountType.VENDOR
          ? of(true)
          : this.sbStrategyService.hasBrands(am.accountId, am.marketplace).pipe(startWith(undefined)),
      ),
    ),
    { initialValue: true },
  );
  readonly CampaignType = CampaignType;
}
